/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plum_Deep_Fox_RoamInputs */

const en_plum_deep_fox_roam = /** @type {(inputs: Plum_Deep_Fox_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Changes`)
};

const de_plum_deep_fox_roam = /** @type {(inputs: Plum_Deep_Fox_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen speichern`)
};

/**
* | output |
* | --- |
* | "Save Changes" |
*
* @param {Plum_Deep_Fox_RoamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plum_deep_fox_roam = /** @type {((inputs?: Plum_Deep_Fox_RoamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plum_Deep_Fox_RoamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plum_deep_fox_roam(inputs)
	return de_plum_deep_fox_roam(inputs)
});